<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  {{data.message}}
</div>
<div mat-dialog-actions>
  <!-- OK only dismisses the dialog. It used to also call Logout(), which sent the
       user through Auth0's /v2/logout with returnTo = environment.auth.logoutUri;
       when that URL is not an Allowed Logout URL for this Auth0 application, Auth0
       falls back to one that is and the user lands in a DIFFERENT environment
       (a dev sign-in failure ended up on production). Keeping the user where they
       are also leaves the failure visible instead of bouncing them away. -->
  <button mat-button mat-dialog-close cdkFocusInitial>OK</button>
</div>